import { useSearchConnectedShopsQuery } from '../features/chat/chatApiSlice';

export const useSearchConnections = (params, options = {}) => {
  const result = useSearchConnectedShopsQuery(params, options);
  return result;
};

export default useSearchConnections;
